export function isRportPtzEnabled(
  stream?: VideoStream,
  features?: StreamFeatures,
  isMobile?: boolean,
  isSmallScreen?: boolean
): boolean {
  return Boolean(
    (features?.ptz.active && features?.ptz.write) &&
    stream?.rportCameraId &&
    stream?.ptz?.rport !== false &&
    !isMobile &&
    !isSmallScreen
  );
}
